<template>
	<div class="m-dropdown nk-control" :tabindex="disable ? null : 0" @focus="focusInput" @focusout="focusOut" :title="tooltipTitle" :is-open="isOpen ? true : null">
		<div class="m-dropdown-bar ncontrol-container" ref="bar">
			<div class="m-dropdown-input selected-items" ref="inputsParent" :tabindex="!settings.clearable ? tabindex : null">
				<slot name="items"></slot>
				<nk-input :disabled="disable || !settings.clearable" :ancestor-name="ancestorName" v-model="displayText" @update:modelValue="displayTextChanged" :options="inputOptions" :tabindex="disable ? null : tabindex" :is-open="isOpen ? true : null" class="m-dropdown-input" :startup="startup ? true : null" ref="input"></nk-input>
				<nk-input class="m-dropdown-input" :options="inputOptions" ref="input2" style="width: 0;height: 0;position: absolute;margin-top: -100px;opacity: 0;"></nk-input>
				<div class="ncontrol-button clear-selection">
					<button type="button" v-if="!dropdownIsEmpty && !disable && settings.clearable" @click="clearSelection">
						<span>
							<icon icon="times" group="light" />
						</span>
					</button>
				</div>
			</div>
			<div :disabled="disable ? true : null" :class="{ 'ncontrol-button': true, toggler: ancestorName != 'cells', 'without-reduce': ancestorName == 'cells' }">
				<button type="button" @click="togglerClicked" ref="togglerButton">
					<span>
						<icon icon="angle-down" group="light" />
					</span>
				</button>
			</div>
		</div>
		<div :class="['m-dropdown-selector', { 'focused': !inputIsFocused }]" ref="selector" :tabindex="disable ? null : 0">
			<div v-if="selectorShow" class="m-dropdown-selector-content" ref="selector">
				<component :focusAndSelect="focusAndSelectionAgGrid" :modelValue="componentModelValue" :is="localComponent" :data="filteredItems" :options="componentOptions" @activeIndex="(index) => activeIndex = index" :active-index="componentActiveIndex" @rendered="selectorRendered" @update:modelValue="selectedFromListChanged" @enter-pressed="enterPressed" @buttons-changed="buttonsChanged" @title-changed="titleChanged" @reject="rejected" @grid-focus-out="focusInput"
					@grid-server-result="processGridServerResult" ref="comp">
				</component>
			</div>
			<div class="m-dropdown-selector-toolbar" v-if="allButtons.length > 0">
				<nk-button v-for="(b, i) in allButtons" :key="i" :tabindex="i + 1" :class="['btn mr-1', 'btn-sm', { 'btn-primary': b.isPrimary }]" :options="b" @click="buttonClicked">
				</nk-button>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'
	import _, { drop } from 'lodash'
	import List from '~/components/general/nikan-list'
	import TabOrder, { Next } from '~/statics/taborder-functions'
	import { post } from '~/plugins/nikan-api'
	import { mapActions } from 'vuex'
	import cloneDeep from 'lodash/cloneDeep'

	const elementRect = (el) => {
		let boundingRect = el.getBoundingClientRect()
		let view = el.ownerDocument.defaultView

		let top = boundingRect.top + view.pageYOffset
		let left = boundingRect.left + view.pageXOffset

		let bottom = top + boundingRect.height
		let right = window.innerWidth - boundingRect.right

		return { top, right, bottom, left }
	}

	export default {
		props: {
			params: {
				type: Object,
			},
			options: {
				type: Object,
			},
			data: {},
			tabindex: { default: 0 },
			component: {},
			buttons: {},
			disabled: { type: Boolean, default: false },
			modelValue: {},
			startup: { type: Boolean },
			tooltip: { type: String },
			small: { type: Boolean, default: false },
			inputOpts: { type: Object },
			ancestorName: { type: String, default: null }
		},
		emits: ['update:modelValue', 'inputTextChangeEmit', 'selectorRendered', 'selectorOpened'],
		data() {
			return {
				displayTextSetTimeout: null,
				selectorShow: false,
				userIsTyping: false,
				timeoutUserIsTyping: null,
				activeIndex: null,
				isEnterPressed: false,
				focusOutTimeout: null,
				settings: {
					clearable: true,
					hideEmptyMsg: false,
					rowIdentifier: null,
					url: null,
					disable: false,
					searchable: true,
					findExactMatch: null,
					clientSearch: null,
					required: false,
					remoteSearch: false,
					loadOnMount: true,
					selectorWidth: null,
					selectorHeight: 'auto',
					emitNullOnNotFound: false,
					getDataFromOptions: false,
					searchPrefix: null,
					lowerCaseSearch: true,
					component: {
						type: List,
						options: {
							multiSelection: this.options?.multiSelection,
						},
					},
					buttons: [],
					display: (item) => {
						if (item.name) {
							return item.name
						} else if (item.text) {
							return item.text
						} else if (item.value) {
							return item.value
						} else if (item.title) {
							return item.title
						}
						return item
					},
					targetField: null,
					searchableFields: [],
					autoSelectWhenOneItemExist: false
				},
				inputOptions: {
					required: true,
					placeholder: '',
				},
				isOpen: false,
				allSelectedItems: [],
				filteredSelectedItems: [],
				selectedItem: null,
				componentButtons: null,
				retreivedDataFromServer: [],
				filteredItems: [],
				inputOldValue: '',
				inputIsFocused: true,
				componentActiveIndex: -1,
				selectorWait: null,
				lastSearchRequest: null,

				innerSet: false,

				lastSelectedItem: null,
				local_selector: null,
			}
		},
		computed: {
			componentModelValue() {
				if (this.settings.multiSelection && this.agServerSideStatus) {
					return this.allSelectedItems
				}

				if (this.settings.multiSelection) {
					return this.filteredSelectedItems
				}
				return this.selectedItem
			},
			focusAndSelectionAgGrid() {
				return this.settings.component.options.focusAndSelect = {
					isOpen: this.isOpen,
					allowFocus: !this.userIsTyping || this.settings.multiSelection
				}
			},
			disable() {
				return this.settings.disable || this.disabled
			},
			localComponent() {
				return this.makeRawComponent(this.settings.component.type)
			},
			componentOptions() {
				let defs = {
					display: this.settings.itemDisplay || this.display,
				}
				return _.extend(defs, this.settings.component.options)
			},
			allButtons() {
				var array = []

				if (this.settings.buttons.length) {
					array = [...this.settings.buttons]
				}

				if (this.componentButtons && this.componentButtons.length) {
					array = [...array, ...this.componentButtons]
				}

				array.forEach(btn => {
					btn.disabled = btn.disabled === null || btn.disabled === undefined ? this.disable : btn.disabled
				})

				return array
			},
			display() {
				if (_.isFunction(this.settings.display)) {
					return this.settings.display
				} else {
					return (item) => item
				}
			},
			displayText: {
				get: function () {
					if (this.settings.multiSelection) return ''

					if (this.selectedItem == null) {
						if (this.innerSet) {
							// this.innerSet = false
							return this.inputOldValue
						}

						return null
					}

					if (this.display) {
						this.inputOldValue = this.display(this.selectedItem)
					}

					this.innerSet = false
					return this.inputOldValue
				},
				set: function (val) {
					if (this.inputOldValue !== val) {
						this.inputOldValue = val

						this.innerSet = val !== ''

						if (this.selectedItem != null) {
							this.lastSelectedItem = this.selectedItem
							if (!this.settings.multiSelection) {
								this.selectedItem = null
								this.$emit('update:modelValue', null)
							}
						}
						// if(val)
						if (this.agServerSideStatus)
							this.agGridSearch(val)
						else if (this.settings.remoteSearch === true) {
							this.serverSearch(val)
						} else {
							this.clientSearch(val)
						}
					}
				},
			},
			agServerSideStatus() {
				return this.settings?.component?.type === 'ag-grid' && this.settings.component.options?.rowModelType === 'serverSide'
			},
			selectorId() {
				return 'dd-' + this.uid()
			},
			localData: {
				get() {
					let temp = (
						(this.settings.getDataFromOptions === true
							? (typeof (this.settings.data) === 'function' ? this.settings.data() : this.settings.data)
							: this.data) || this.retreivedDataFromServer
					)
					return temp
				},
				set(val) {
					this.retreivedDataFromServer = val
				},
			},
			tooltipTitle() {
				if (this.tooltip)
					return this.tooltip
				else if (this.displayText)
					return this.displayText
				else
					return this.inputOptions.placeholder
			},
			dropdownIsEmpty() {
				if (this.settings.multiSelection) {
					return _.isEmpty(this.filteredSelectedItems) && _.isEmpty(this.displayText)
				}
				return _.isEmpty(this.selectedItem) && _.isEmpty(this.displayText)
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
					if (this.settings.component.options.serverInfo && !this.selectedItem)
						this.settings.component.options.serverInfo.payload.filter = { ...this.settings.component.options.serverInfo.payload.filter, searchTerm: this.displayText }

					if (this.disable && this.$refs.input2 && !this.settings.dontFocusOnDisable)
						this.$refs.input2.onFocused()
					else if (this.settings.focus)
						this.focusInput()
				},
			},
			params: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val?.options ? val.options : {})
				},
			},
			modelValue: {
				deep: true,
				handler(val) {
					// this.clear()
					if (this.settings.multiSelection) {
						this.allSelectedItems = Array.isArray(val) ? val : []
						this.updateFilteredSelectedItems()
					} else {
						this.selectedItem = this.getValidValue(val)
					}
				},
			},
			data: {
				deep: true,
				immediate: true,
				handler(val) {
					if (this.settings.loadOnMount)
						this.filteredItems = this.localData
					this.selectedItem = this.getValidValue(this.modelValue)

					this.defer(() => {
						if (val?.length === 1 && this.settings.autoSelectWhenOneItemExist) {
							if (!this.selectedItem) {
								this.selectedItem = this.getValidValue(val[0])
								this.$emit('update:modelValue', this.selectedItem)
							}
						}
					}, 200)
				},
			},
			disable: {
				handler(val, oldVal) {
					if (val !== oldVal) {
						this.allButtons.forEach(button => {
							button.disabled = val
						})
						this.defer(() => {
							let grandParentType = this.grandParentType()
							TabOrder.subscribeKeys(grandParentType, this)
						}, 500)
					}
				},
			},
		},
		methods: {
			...mapActions({
				menu_show: 'hide_show',
			}),
			selectorRendered() {
				// if (!this.settings.url && !this.settings.loadOnMount && this.localComponent == 'ag-grid')
				// this.defer(() => this.filteredItems = this.localData, 100)
				this.$emit('selectorRendered')
			},
			arrowDownOnInput(e) {
				if (this.isOpen) {
					e.preventDefault()
					this.userIsTyping = false
					this.focusComponent()
				}

			},
			getActiveIndex(val) {
				this.activeIndex = val
			},
			defaultFindExactMatch() {
				let inputValue = this.$refs.input.pureValue()
				let fields = this.settings.searchableFields
				var filtered = (this.filteredItems || []).filter(x => {
					for (let field of fields) {
						if (this.settings.searchPrefix)
							return this.$t(`${this.settings.searchPrefix}.${_.get(x, field, x).toLowerCase()}`) === inputValue
						else
							return `${_.get(x, field)}` === inputValue
					}
				})
				if (filtered.length === 1) {
					return filtered[0]
				}
			},
			getInput() {
				return this.$refs.input
			},
			focusOut() {
				if (this.isOpen && this.isEnterPressed) {
					// if (!this.filteredItems || !this.filteredItems.length) {
					this.closeSelector(false)
					// }
				}
				this.isEnterPressed = false

				if (this.focusOutTimeout)
					clearTimeout(this.focusOutTimeout)

				this.focusOutTimeout = setTimeout(() => {
					if (!this.selectedItem && !this.isOpen) {
						this.displayText = ''
					}
				}, 110) // Sets 110ms because body event listener(in openSelector function) that closes dropdown has 100ms timeout

			},
			// api
			state_open() {
				this.userIsTyping = true
				this.openSelector(false)
			},
			state_close() {
				this.closeSelector()
			},
			api_backToLastSelectedItem() {
				if (this.lastSelectedItem) {
					this.selectedItem = this.lastSelectedItem
					this.lastSelectedItem = null
				}
			},
			checkDropPosition(dropHeight, dropTop, dropRight) {
				if (dropHeight === 'auto') {
					dropHeight = $(this.$refs.selector).height()
				}
				let rect_selector = elementRect(this.$refs.selector)
				let rect_nkPage = elementRect(document.querySelector('.nk-tabs-component-panels'))
				let rect_bar = elementRect(this.$refs.bar)

				let spaceTop = rect_bar.top - rect_nkPage.top
				let spaceBottom = rect_nkPage.bottom - dropTop

				let maxHeight
				let dropBottom = 'auto'
				let minHeight = 200
				if (spaceBottom > minHeight) {
					maxHeight = spaceBottom
				} else {
					maxHeight = spaceTop
					dropBottom = window.innerHeight - rect_bar.top
					dropTop = 'auto'
				}

				if (rect_selector.left < 0) {
					dropRight += rect_selector.left - 28
				} else if (dropRight < 0) {
					dropRight += -dropRight
				}

				return { dropTop, maxHeight, dropRight, dropBottom }
			},

			async openSelector(keepInputFocused) {
				this.$emit('selectorOpened')
				if (this.disable) return
				if (!this.settings.loadOnMount && !this.userIsTyping) {
					this.filteredItems = this.localData
				}
				if (!this.filteredItems?.length && this.settings.hideEmptyMsg) return

				var body = _.head(document.getElementsByTagName('body'))
				let $el = $(this.$el)
				let $bar = $(this.$refs.bar)
				let $selector = $(this.$refs.selector)

				body.appendChild(this.$refs.selector)
				// $(this.$el).append($selector)

				let leftouts = $('body > .m-dropdown-selector')
				if (leftouts.length) {
					this.defer(() => {
						leftouts.each((index, el) => {
							if (el !== this.$refs.selector) {
								$(el).remove()
							}
						})
					}, 500)
				}

				let rect = elementRect(this.$refs.bar)
				let minWidth = $bar.width()
				let widthFromSettings = parseFloat(this.settings.selectorWidth)
				let width = Math.max(widthFromSettings || 0, minWidth)
				$selector.css({
					'min-width': minWidth,
					width: width,
					top: rect.bottom, //  this.options.top ? this.options.top : '26px',
					right: rect.right, //this.options.right ? this.options.right : 0,
					position: 'absolute',
				})

				$el.addClass('open')
				$selector.addClass('detached')

				this.selectorShow = true
				$selector.css({
					opacity: 1,
					height: this.settings.selectorHeight,
					display: 'flex',
					overflow: 'hidden',
				})
				let checked = this.checkDropPosition(this.settings.selectorHeight, rect.bottom, rect.right)
				$selector.css({
					'top': checked.dropTop,
					'max-height': checked.maxHeight,
					'right': checked.dropRight,
					'bottom': checked.dropBottom
				})
				this.defer(() => {
					// body.removeEventListener('click', document.bodyClickHandler)
					// body.addEventListener('click', document.bodyClickHandler)
					document.removeEventListener('scroll', this.closeOnScroll, true)
					document.addEventListener('scroll', this.closeOnScroll, true)
					body.removeEventListener('click', this.test, true)
					body.addEventListener('click', this.test, true)
				}, 100)

				this.isOpen = true

				this.$refs.input.$el.querySelector('input').focus()


				// if (!this.userIsTyping) {
				// 	this.defer(this.focusComponent, 2)
				// }

				let comp = this.$refs.comp

				this.defer(() => {
					if (typeof comp?.init === 'function') {
						comp.init()
					}
				}, 100)
				if (this.settings.component && this.settings.component.options) {
					// var clone = _.cloneDeep(this.settings)
					this.settings.component.options.maxHeight = checked.maxHeight - (this.allButtons.length > 0 ? 38 : 0)
					// this.settings = clone
				}

			},
			closeSelector(refocus = true) {
				let $selector = $(this.$refs.selector)
				if (!$selector) {
					$selector = this.local_selector
				}
				this.selectorShow = false
				$selector.css({
					height: '0',
					opacity: 1,
					display: 'none',
					'max-height': 'auto'
				})
				$(this.$el).append($selector)
				$selector.removeClass('detached')
				$(this.$el).removeClass('open')

				if (refocus) {
					this.defer(this.focusInput, 50)
				}

				this.isOpen = false
			},
			test(event) {
				var body = _.head(document.getElementsByTagName('body'))
				const isEqual = (target) => (el) => el === target
				const isSelector = isEqual(this.$refs.selector)
				const isRoot = isEqual(this.$el)

				const els = [
					event.target,
					...$(event.target)
						.parents()
						.map((index, el) => el),
				]
				const ignore = els.filter((el) => isSelector(el) || isRoot(el)).length > 0 || body.popover_clicked
				if (!ignore) {
					this.closeSelector(false)
					body.removeEventListener('click', this.test)
				}
				body.popover_clicked = false

			},
			closeOnScroll(event) {
				onclose = ['overflow-auto', 'nk-stabs-panels', 'virtual-scroller', 'h-grow-lock', 'nk-page-body'] // close dropdown when user scroll's in these elements (by class)
				let exist = [...event.target.classList].map(x => {
					return { cl: x }
				}).findIndex(x => onclose.indexOf(x.cl) > -1) > -1
				if (exist && event.target.contains(this.$el)) {
					this.closeSelector(false)
					document.removeEventListener('scroll', this.closeOnScroll, true)
				}
			},
			// button
			buttonClicked(button, e) {
				e.preventDefault()
				var handle = button.handle
				if (handle != null && button.visible != false && !this.disable) {
					handle(button, this.selectedItem, e)
					// temp solution
					this.closeSelector(false)
				}
			},
			togglerClicked(event) {
				if (event) {
					event.preventDefault()
				}
				this.userIsTyping = false
				if ($(this.$el).hasClass('open')) {
					this.closeSelector()
				} else {
					this.userIsTyping = true

					const searchText = this.$refs.input?.pureValue() ?? ''
					if (searchText && this.settings.multiSelection) {
						if (this.agServerSideStatus) {
							this.agGridSearch(searchText)
						} else if (this.settings.remoteSearch === true) {
							this.serverSearch(searchText)
						} else {
							this.clientSearch(searchText)
						}
					} else {
						this.filteredItems = this.localData
					}

					this.updateFilteredSelectedItems()
					this.settings.component.options.fitToWidth = this.settings.component.options.fitToWidth + 1
					this.openSelector(this.$el)
				}
			},
			clear() {
				this.selectedItem = null
				this.inputOldValue = ''
			},
			focusAndSelect() {
				this.$el.focus()
				this.defer(() => $(this.$refs.input.$el).find('input').select(), 5)
			},
			refreshRemote() {
				return new Promise((resolve, reject) => {
					if (this.settings.url) {
						this.getDataFromUrl()
							.then((result) => resolve(result))
							.catch((error) => reject(error))
					} else {
						reject(new Error('dropdown url did not set'))
					}
				})
			},

			// component
			buttonsChanged(buts) {
				this.componentButtons = buts
			},
			titleChanged(title) {
			},
			rejected(error) {
				this.logger.error(error)
			},
			focusComponent() {
				this.resetComponentActiveIndex()
				let comp = this.$refs.comp
				this.defer(() => {

					if (this.settings?.component?.type === 'ag-grid')
						this.$refs.comp?.focusOnGrid()
					else
						$(comp.$el).trigger('focus')
				}, 5)
			},
			resetComponentActiveIndex() {
				this.componentActiveIndex =
					this.componentActiveIndex < 0 ? this.componentActiveIndex - 1 : -1
			},
			focusInput() {
				if (this.$refs.inputsParent && !this.settings.clearable)
					this.$refs.inputsParent.focus()
				else if (this.$refs.input && !this.disable)
					this.$refs.input.onFocused()
				else if (this.$refs.input2)
					this.$refs.input2.onFocused()

				if (this.focusOutTimeout)
					clearTimeout(this.focusOutTimeout)
			},
			getValidValue(val) {
				if (this.filteredItems && this.filteredItems.length > 0 && val) {
					let index
					if (this.rowIdentifierKey() != null) {
						index = this.filteredItems.findIndex(
							(x) => this.rowIdentifier(x) === this.rowIdentifier(val)
						)
					} else if (this.settings.targetField && val) {
						index = this.filteredItems.findIndex(x => x[this.settings.targetField] === val)
					} else {
						index = this.filteredItems.findIndex((x) => _.isEqual(x, val))
					}

					if (index > -1) {
						return this.filteredItems[index]
					} else if (this.settings.emitNullOnNotFound === true) {
						this.lastSelectedItem = this.selectedItem
						this.$emit('update:modelValue', null)
						return null
					}
				} else if (this.settings.emitNullOnNotFound === true) return null

				return val
			},
			rowIdentifier(item) {
				let id

				if (this.settings.rowIdentifier != null) {
					if (_.isFunction(this.settings.rowIdentifier)) {
						id = this.settings.rowIdentifier(item)
					} else {
						id = this.settings.rowIdentifier
					}
					return _.get(item, id)
				} else {
					return null
				}
			},
			rowIdentifierKey() {
				let id = null

				if (this.settings.rowIdentifier != null) {
					if (_.isFunction(this.settings.rowIdentifier)) {
						id = this.settings.rowIdentifier()
					} else {
						id = this.settings.rowIdentifier
					}
				}
				return id
			},

			// data
			getUrl() {
				if (typeof this.settings.url === 'string') {
					return this.settings.url
				} else if (typeof this.settings.url === 'function') {
					return this.settings.url(this.localData, this.selectedItem)
				} else if (_.has(this.settings.url, 'address')) {
					return this.settings.url.address
				}
			},
			getRequestData(keyword, searchType) {
				var obj = { keyword, searchType }

				if (typeof this.settings.searchRequestFilter === 'function') {
					var res = this.settings.searchRequestFilter(this.selectedItem, obj)
					obj = $.extend(true, {}, obj, res)
				}

				return obj
			},
			getDataFromUrl(keyword = '') {

				return new Promise((resolve, reject) => {
					this.defer(() => {
						var wait = this.$wait(this.$el, { size: 'small' })

						const url = this.getUrl()
						if (!url) {
							return
						}

						post(url, this.getRequestData(keyword, 0), (result) => {
							wait.end()
							if (result.success) {
								if (_.has(result.data, 'items')) {
									this.filteredItems = this.retreivedDataFromServer =
										result.data.items ? result.data.items : []
								} else {
									this.filteredItems = this.retreivedDataFromServer = result.data ? result.data : []
								}
								resolve()
							} else {
								this.retreivedDataFromServer = []
								this.logger.error(result.message)
								reject(new Error(result.message))
							}

							this.defer(() => {
								this.focusAndSelect()
								this.focusComponent()
							}, 100)
						})
					}, 5)
				})
			},
			updateFilteredSelectedItems() {
				this.filteredSelectedItems = _.intersectionBy((this.allSelectedItems), (this.filteredItems), this.rowIdentifier)
			},
			selectedFromListChanged(value) {
				if (this.settings.multiSelection) {
					const newSelections = Array.isArray(value) ? value : []

					if (this.agServerSideStatus) {
						this.allSelectedItems = newSelections
					} else {
						const preservedOutsideFilter = _.differenceBy(this.allSelectedItems, this.filteredItems, this.rowIdentifier)
						this.allSelectedItems = _.unionBy(preservedOutsideFilter, newSelections, this.rowIdentifier)
					}
					this.filteredSelectedItems = newSelections

					if (this.settings.targetField) {
						this.$emit('update:modelValue', this.allSelectedItems.map(x => x?.[this.settings.targetField]))
					} else {
						this.$emit('update:modelValue', this.allSelectedItems)
					}
				} else {
					this.selectedItemChanged(value)
				}
			},
			selectedItemChanged(item) {
				if (this.settings.targetField && item)
					this.$emit('update:modelValue', item[this.settings.targetField])
				else
					this.$emit('update:modelValue', item)
				this.userIsTyping = false

				this.defer(() => {
					if (this.isOpen && !this.settings.multiSelection) {
						this.togglerClicked()
					}
				}, 50)

				if (this.settings.onChangeHandler && typeof this.settings.onChangeHandler == 'function' && item) {
					this.settings.onChangeHandler(item)
				}
			},
			enterPressed() {
				if (this.isOpen && this.settings.multiSelection) {
					this.togglerClicked()
				}
			},
			getDataFromUrlWithSearch(requestData) {
				const setFoundItem = () => {
					this.resetComponentActiveIndex()

					if (this.filteredItems && this.filteredItems.length > 0) {
						if (this.filteredItems.length === 1) {
							this.selectedItemChanged(this.filteredItems[0])
							this.closeSelector()
							if (this.isEnterPressed && !this.options.scannerMood) {
								let e = $.Event('keypress')
								e.keyCode = 13 // enter
								var tabindex = $(this.$refs.input.$el).attr('tabindex')
								if (tabindex == 0) {
									const foundEvent = this.$keyHandler.Handlers.filter(x => x.name.includes('table-arrow-left')).reduce((a, c) => _.last(c.name.split('-')) > _.last(a.name.split('-')) ? c : a
										, { name: '' })
									if (foundEvent) foundEvent.handler(this.$refs.input.$refs.input, e, this.$parent?.$parent?.$parent?.$parent ? this.$parent.$parent.$parent.$parent : null)
								} else {
									this.defer(() => Next(this.$refs.input.$el, e), 100)
								}
							}
						} else {
							this.focusAndSelect()
							this.focusComponent()

						}
					}
				}
				if (this.lastSearchRequest === -1) {
					this.lastSearchRequest = null
					return
				}

				if (!$(this.$el).has(':focus').length > 0) {
					return
				}
				this.state_open()
				if (_.isEqual(requestData, this.lastSearchRequest)) {
					// this.isOpen = false
					setFoundItem()
					return
				}


				if (this.selectorWait != null) {
					this.selectorWait.end()
				}

				this.selectorWait = this.$wait(this.$refs.selector, { size: 'small' })

				this.lastSearchRequest = requestData

				post(this.getUrl(), requestData, (result) => {
					this.selectorWait?.end()
					this.selectorWait = null

					if (!_.isEqual(requestData, this.lastSearchRequest)) {
						return
					}

					if (result.success) {
						if (_.has(result.data, 'items')) {
							this.filteredItems = result.data.items
						} else {
							this.filteredItems = result.data
						}
						setFoundItem()
					} else {
						this.isOpen = false
					}
				})
			},
			clearSelection() {
				if (this.settings.multiSelection) {
					this.filteredSelectedItems = []
					this.$emit('update:modelValue', [])
				} else {
					this.selectedItem = null
					this.selectedItemChanged(null)
				}

				this.displayText = ''
			},
			agGridSearch(keyword) {
				const cloneFilter = cloneDeep(this.options.component.options.serverInfo.payload.filter)
				const searchFields = this.settings.component.options.serverInfo.searchableFields.reduce((a, x) => {
					if (typeof x === 'function') {
						if (!Array.isArray(a.SchemaValues)) a.SchemaValues = []
						a.SchemaValues.push(x(keyword))
					} else
						a = { ...a, [x]: keyword }
					return a
				}, cloneFilter)
				if (!this.selectedItem || this.selectedItem.length === 0)
					this.settings.component.options.serverInfo.payload.filter = { ...searchFields, searchTerm: keyword }

				this.refreshServerSideTimeout && clearTimeout(this.refreshServerSideTimeout)
				this.refreshServerSideTimeout = setTimeout(() => {
					if (!this.isOpen && $(this.$el).has(':focus').length > 0) {
						this.state_open()
						this.resetComponentActiveIndex()
					} else {

						if (this.$refs.comp) {
							this.$refs.comp.serverInfo.payload.filter = { ...searchFields, searchTerm: keyword }
							this.$refs.comp.gridApi.refreshServerSide({ purge: true })
						}
					}
					this.updateFilteredSelectedItems()
				}, 1500)


			},
			serverSearch(keyword) {
				this.isOpen = true

				if (!keyword) {
					this.state_close()

					this.lastSearchRequest = -1
					return
				} else if (this.lastSearchRequest === -1) {
					this.lastSearchRequest = null
				}

				this.getDataFromUrlWithSearch(this.getRequestData(keyword, 0))
				this.updateFilteredSelectedItems()
			},
			clientSearch(keyword) {

				if (this.settings.clientSearch && typeof this.settings.clientSearch === 'function')
					this.filteredItems = this.settings.clientSearch(keyword, this.localData)

				else {
					keyword = keyword || ''
					let words = keyword.getWords()
					let fields = this.settings.searchableFields
					let filtered = this.localData

					if (fields == null || !$.isArray(fields) || fields.length === 0) {
						fields = ['name']
					}

					for (let i = 0; i < words.length; i++) {
						filtered = filtered.filter((x) => {
							let flag = false
							for (let j = 0; j < fields.length; j++) {
								if (this.settings.searchPrefix) {
									if (typeof fields[j] === 'function')
										flag = flag || this.$t(`${this.settings.searchPrefix}.${this.settings.lowerCaseSearch ? fields[j](x).toLowerCase() : fields[j](x)}`).indexOf(words[i]) > -1
									else
										flag = flag || this.$t(`${this.settings.searchPrefix}.${this.settings.lowerCaseSearch ? _.get(x, fields[j], x).toLowerCase() : _.get(x, fields[j], x)}`).indexOf(words[i]) > -1
								} else {
									if (typeof fields[j] === 'function')
										flag = flag || `${fields[j](x)}`.indexOf(words[i]) > -1
									else
										flag = flag || `${_.get(x, fields[j])}`.indexOf(words[i]) > -1
								}
							}
							return flag
						})
					}
					this.filteredItems = filtered
				}
				this.updateFilteredSelectedItems()

				if (!this.isOpen && $(this.$el).has(':focus').length > 0) {
					this.state_open()
					this.resetComponentActiveIndex()
				}
			},
			displayTextChanged(val) {
				if (this.settings.enableInputTextChangeEmit)
					this.$emit('inputTextChangeEmit', val)
			},
			processGridServerResult(result) {
				const isEmpty = !this.selectedItem || (Array.isArray(this.selectedItem) && this.selectedItem.length === 0)
				if (result.request.page === 1 && result.request.searchValue && result.response.length === 1 && isEmpty) {
					this.selectedFromListChanged(result.response[0])
				}
			},
			handleAgGridServerSideEnter() {
				this.isEnterPressed = false

				if (!this.displayText?.length) return false

				if (!this.$refs.comp || !this.$refs.comp.gridApi || this.$refs.comp.isServerSideLoading) return true

				const rows = this.$refs.comp.gridApi.getDisplayedRowCount()
				if (rows === 0) {
					$(this.$refs.input.$el).find('input').select()
					return true
				} else if (rows === 1) {
					this.selectedItemChanged(this.$refs.comp.gridApi.getDisplayedRowAtIndex(0)?.data)

					if (this.isOpen) {
						this.togglerClicked()
					}
				} else {
					return false
				}

				return true
			},
			handleClientSideEnter(text) {
				let match
				if (this.settings.findExactMatch && $.isFunction(this.settings.findExactMatch))
					match = this.settings.findExactMatch(this.localData, text)
				else
					match = this.defaultFindExactMatch()

				if (Array.isArray(match)) {
					this.selectedItemChanged(match)

					return new Promise((resolve, reject) => {
						this.defer(resolve, 5)
					})
				}
				if (match != null && this.localData.indexOf(match) > -1) {
					this.selectedItemChanged(match)

					return new Promise((resolve, reject) => {
						this.defer(resolve, 5)
					})
				} else if (match === null) {
					this.filteredItems = []
				} else if (!text) {
					return false
				} else if (this.filteredItems && !this.filteredItems.length) {
					$(this.$refs.input.$el).find('input').select()
					return true
				} else if (text && (!this.filteredItems || !this.filteredItems.length) && this.settings.remoteSearch) {
					$(this.$refs.input.$el).find('input').select()
					return true
				}

				if (this.isOpen && this.filteredItems && this.filteredItems.length > 0 && !this.settings.remoteSearch) {
					if (this.filteredItems.length === 1) {
						this.selectedItemChanged(this.filteredItems[0])

						if (this.isOpen) {
							this.togglerClicked()
						}
					} else {
						this.defer(this.focusComponent, 1)
					}
					return true
				} else {
					this.closeSelector(false)
				}
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'm-dropdown-button-click',
					el: [this.$el, this.$refs.selector],
					ctrlKey: undefined,
					altKey: undefined,
					shiftKey: undefined,
					context: this,
					handler: function (sender, e) {

						var _buttons = [...this.allButtons]
						for (var i = 0; i < _buttons.length; i++) {
							var b = _buttons[i]
							if (typeof b.shortcut === 'undefined') {
								b.shortcut = {}
							}

							if (
								b.shortcut.keyCode === e.keyCode &&
								(typeof b.shortcut.ctrlKey === 'undefined' ||
									b.shortcut.ctrlKey === e.ctrlKey) &&
								(typeof b.shortcut.shiftKey === 'undefined' ||
									b.shortcut.shiftKey === e.shiftKey) &&
								(typeof b.shortcut.altKey === 'undefined' ||
									b.shortcut.altKey === e.altKey)
							) {
								e.preventDefault()
								this.buttonClicked(b, e)

								return true
							}
						}
					},
				}) // dropdown-button-click
				this.$keyHandler.Subscribe({
					name: 'm-dropdown-open',
					keyCode: [40, 32], // 40:arrow-down 32:space
					ctrlKey: true,
					el: [this.$el, this.$refs.selector],
					context: this,
					handler: function (sender, e) {
						if (!this.disable && !this.isOpen) {
							this.togglerClicked()
							// this.openSelector(true)
							if ((this.filteredItems || []).length > 0) {
								this.defer(this.focusComponent, 1)
							}
							return true
						}
					},
				}) // dropdown-open
				if (this.$refs.input) {
					// this.$keyHandler.Subscribe({
					// 	name: 'm-dropdown-component-focus',
					// 	keyCode: 40, // 40:arrow-down
					// 	el: this.$refs.input.$el,
					// 	context: this,
					// 	handler: (sender, e,isOpen=this.isOpen) => {
					// 		// if(isOpen) {
					// 		this.focusComponent()
					// 		return true
					// 		// }
					// 	},
					// }) // component-focus on arrow-down
					this.$keyHandler.Subscribe({
						name: 'm-dropdown-find-exact-match',
						keyCode: 13, // 13:enter
						el: this.$refs.input.$el,
						context: this,
						test: function (sender, e) {
							this.isEnterPressed = true
							return this.selectedItem == null
						},
						handler: function (sender, e) {
							if (e.ctrlKey || this.disable) return
							e.preventDefault()

							if (this.agServerSideStatus) {
								return this.handleAgGridServerSideEnter()
							}

							this.isEnterPressed = true
							let text = this.$refs.input.pureValue()
							return this.handleClientSideEnter(text)
						},
					}) // component-focus on enter
					this.$keyHandler.Subscribe({
						name: 'm-dropdown-input-tab',
						keyCode: 9, // 9:tab
						el: this.$refs.input.$el,
						context: this,
						handler: function (sender, e) {
							e.preventDefault()
							if (this.disable) return
							if ($(this.$el).hasClass('open')) this.closeSelector(false)
							return false
						},
					}) // component-focus on enter
					this.$keyHandler.Subscribe({
						name: 'm-dropdown-close-on-arrows',
						keyCode: [37, 39], // 37:arrow-left 39:arrow-right
						el: this.$refs.input.$el,
						context: this,
						handler: function (sender, e) {
							if (this.isOpen) {
								if (this.$refs.input.$refs.input.selectionStart === 0 || this.$refs.input.$refs.input.selectionStart >= this.$refs.input.$refs.input.value.length - 1) {
									this.closeSelector(false)
								}
							}
						},
					}) // close dropdown on arrow-left & arrow-right
					this.$keyHandler.Subscribe({
						name: 'm-dropdown-close',
						keyCode: [38, 27], // 38:arrow-up 27:escape
						el: [this.$refs.input.$el, this.$refs.selector],
						context: this,
						handler: function (sender, e) {
							if (this.isOpen) {
								this.closeSelector()


								return true
							}
						},
					}) // arrow-up & escape
					this.$keyHandler.Subscribe({
						name: 'm-dropdown-open-list',
						keyCode: [40], // 40:arrow-down
						el: [this.$refs.input.$el,],
						context: this,
						handler: function (sender, e) {
							if (this.isOpen) {
								e.preventDefault()
								this.userIsTyping = false
								this.focusComponent()
								return true
							}
							return false
						},
					}) // open selector by arrow down
				}
			},
		},
		created() {
			if (this.inputOpts) {
				this.inputOptions = this.inputOpts
			}

			this.getDataFromUrlWithSearch = _.debounce(
				this.getDataFromUrlWithSearch,
				500
			)
			this.clientSearch = _.debounce(this.clientSearch, 20)

			if (this.settings.loadOnMount)
				this.filteredItems = this.localData
			this.selectedItem = this.getValidValue(this.modelValue)
			this.inputOptions.placeholder = this.settings.placeholder
			if (!this.settings.clearable)
				this.inputOptions.inputClasses = { 'bg-transparent': true }
		},
		mounted() {
			this.local_selector = $(this.$refs.selector)
			if (this.settings.url && this.settings.loadOnMount === true) {
				this.getDataFromUrl().then(() => {
					this.selectedItem = this.getValidValue(this.modelValue)
				})
			}

			let that = this

			$(this.$el).on('click', '.dd-input input', () => {
				that.inputIsFocused = true
			})
			this.allButtons.forEach(button => {
				button.disabled = this.disable
			})
			this.defer(() => {
				this.filteredItems = this.localData
				this.updateFilteredSelectedItems()
			}, 500)
			this.defer(() => {
				TabOrder.subscribeKeys(this.grandParentType(), this)
			}, 2000)
		},
		beforeUnmount() {
			this.closeSelector()

			// Clean up event listeners
			document.removeEventListener('scroll', this.closeOnScroll, true)
			document.body.removeEventListener('click', this.test, true)

			// Clean up jQuery event listeners
			$(this.$el).off('click', '.dd-input input')

			// Clean up specific timers
			if (this.displayTextSetTimeout) {
				clearTimeout(this.displayTextSetTimeout)
			}
			if (this.timeoutUserIsTyping) {
				clearTimeout(this.timeoutUserIsTyping)
			}
			if (this.refreshServerSideTimeout) {
				clearTimeout(this.refreshServerSideTimeout)
			}

			if (document.body) {
				document.body.popover_clicked = false
			}
		},
	}
</script>
